import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { GENESIS, MSERVICES, X_APP_ID_HEADER, X_APP_ID_HEADER_VALUE } from '@rci/self-serve-fido/app.constant';
import { GlobalApiErrorTrackingService } from '@rci/self-serve-fido/core/analytics';
import { LoginService } from '@rci/self-serve-fido/core/fido-login-state/login.service';
import { CustomHttpErrorResponse } from '@rogers/self-serve-common';
import { get, has } from 'lodash';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ResponseInterceptorService implements HttpInterceptor {
  private readonly globalErrorTrackingService = inject(GlobalApiErrorTrackingService);
  private readonly loginService = inject(LoginService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let newReq = req;
    const headers = {};
    if (
      (req.url.indexOf(GENESIS) > -1 || req.url.indexOf(MSERVICES) > -1) &&
      !(req.headers.has(X_APP_ID_HEADER) || req.headers.has('client_id')) &&
      req.url.indexOf('/linked') === -1
    ) {
      headers[X_APP_ID_HEADER] = X_APP_ID_HEADER_VALUE;
      newReq = req.clone({
        setHeaders: headers,
      });
    }

    if (req.url.indexOf(MSERVICES) > -1) {
      newReq = req.clone({
        setHeaders: headers,
        withCredentials: true,
      });
    }

    return next.handle(newReq).pipe(catchError(this.handleError));
  }

  private readonly handleError = response => {
    let errorCode, errorMessage;
    // intercept all kinds of errors and normalize to single error response
    const { status, error } = response;
    errorCode = String(status);
    errorMessage = `${status} - ${response.statusText}`;

    if (status === 401 || status === 440) {
      this.loginService.logOut(true);
    } else if (has(error, 'errorCode')) {
      // Probably response from new backend servers
      errorCode = error.errorCode;
      errorMessage = get(error, 'errorMessage', errorMessage);
    } else if (has(error, 'status.code')) {
      // Probably response from genesis/mservices
      errorCode = get(error, 'status.code');
      errorMessage = get(error, 'status.codeName', '');
    } else if (has(error, 'code')) {
      // Probably response from mobile app team's microservices
      errorCode = get(error, 'code');
      errorMessage = get(error, 'codeName');
    } else if (typeof error === 'string') {
      errorMessage = error;
    }
    const errorObject: CustomHttpErrorResponse = {
      ...response,
      originalError: error,
      error: {
        status: {
          code: errorCode,
          codeName: errorMessage,
        },
      },
    };

    if (!response.url?.includes('/cancel-request-eligibility')) {
      this.globalErrorTrackingService.trackError(errorObject);
    }

    return throwError(() => errorObject);
  };
}
